// extracted by mini-css-extract-plugin
module.exports = {"widgetsContainer":"HomePage_widgetsContainer__1Y5wj"};